export default {
  nome: {
    value: '',
    required: true,
    state: null
  },
  plataforma: {
    value: null,
    options: [
      { value: 1, text: 'E-MAIL' },
      { value: 2, text: 'SMS' },
      { value: 3, text: 'WHATSAPP' }
    ],
    required: true,
    state: null
  },
  situacao: {
    value: null,
    options: [
      { value: 1, text: 'PENDENTE' },
      { value: 2, text: 'ENVIANDO' },
      { value: 3, text: 'ENVIADO' },
      { value: 4, text: 'CONCLUÍDO' }
    ],
    required: true,
    state: null
  },
  servico: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataEnvio: {
    value: null,
    required: false,
    maxlength: 10,
    state: null
  },
  horarioEnvio: {
    value: '',
    required: false,
    maxlength: 10,
    state: null
  },
  campanhaModeloId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  campanhaListaId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  observacao: {
    value: '',
    maxlength: 500,
    required: false,
    state: null,
    rows: 2
  }
}



// WEBPACK FOOTER //
// ./src/views/private/campaign/components/add/campaignadd-form.js